/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum YesNoPartly {
    YES = 'YES',
    NO = 'NO',
    PARTLY = 'PARTLY',
}
